import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'FiltroResultados'
})
export class FiltroResultadosPipe implements PipeTransform {

  transform(arreglo: any[], texto: string): any[] {
   
    //console.log(arreglo)

    if(texto ===''){
      return arreglo
    }

    texto = texto.toLocaleLowerCase()

    return arreglo.filter (item=>{
      return item.estatus.toLocaleLowerCase()
      .includes(texto)
    })
   
    return arreglo;
  }

}
